"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _formatMessage = _interopRequireDefault(require("../format-message"));

require("../rce/languages/it");

/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
var locale = {
  alternative_text_a834dcad: {
    message: "Testo alternativo:"
  },
  announcement_list_da155734: {
    message: "Elenco annunci"
  },
  announcements_a4b8ed4a: {
    message: "Annunci"
  },
  assignments_1e02582c: {
    message: "Compiti"
  },
  background_color_press_down_to_select_ef99fdac: {
    message: "Colore sfondo, premi per selezionare"
  },
  c_2001_acme_inc_283f7f80: {
    message: "(c) 2001 Acme Inc."
  },
  cancel_file_upload_9903e7b9: {
    message: "Annulla caricamento file"
  },
  cancel_image_upload_2c771950: {
    message: "Annulla caricamento immagine"
  },
  cc_attribution_f6de631f: {
    message: "Attribuzione CC"
  },
  cc_attribution_no_derivatives_b006744f: {
    message: "Attribuzione - Non opere derivate CC"
  },
  cc_attribution_non_commercial_39e0d30d: {
    message: "Attribuzione - Non commerciale CC"
  },
  cc_attribution_non_commercial_no_derivatives_9fe74c00: {
    message: "Attribuzione - Non commerciale - Non opere derivate CC"
  },
  cc_attribution_non_commercial_share_alike_c7edb1e5: {
    message: "Attribuzione - Non commerciale - Condividi allo stesso modo CC"
  },
  cc_attribution_share_alike_669e7f16: {
    message: "Attribuzione - Condividi allo stesso modo CC"
  },
  check_if_the_image_is_decorative_283649b7: {
    message: "Verifica se l''immagine \xE8 decorativa"
  },
  choose_usage_rights_33683854: {
    message: "Scegli diritti di utilizzo..."
  },
  click_any_file_to_insert_a_download_link_for_that__a708fa4c: {
    message: "Fai clic su un file per inserire un link di download per il file."
  },
  click_any_image_to_embed_the_image_in_the_page_2cdd1136: {
    message: "Fai clic su un''immagine per incorporare l''immagine nella pagina."
  },
  click_any_page_to_insert_a_link_to_that_page_ac920c02: {
    message: "Fai clic su una pagina per inserire un link a quella pagina."
  },
  click_to_embed_image_33107dd8: {
    message: "Fai clic per incorporare l''immagine"
  },
  click_to_embed_imagename_c41ea8df: {
    message: "Fai clic per incorporare { imageName }"
  },
  click_to_insert_a_link_into_the_editor_c19613aa: {
    message: "Fai clic per inserire un link nell''editor."
  },
  click_to_insert_a_link_to_this_item_39794098: {
    message: "Fai clic per inserire un link a questo elemento."
  },
  close_flickr_form_b32e600a: {
    message: "Chiudi modulo Flickr"
  },
  collaborations_5c56c15f: {
    message: "Collaborazioni"
  },
  copyright_holder_66ee111: {
    message: "Titolare del copyright:"
  },
  course_navigation_dd035109: {
    message: "Esplorazione corso"
  },
  creative_commons_license_725584ae: {
    message: "Licenza Creative Commons:"
  },
  decorative_image_fde98579: {
    message: "Immagine decorativa"
  },
  discussions_a5f96392: {
    message: "Discussioni"
  },
  discussions_index_6c36ced: {
    message: "Indice discussioni"
  },
  embed_image_1080badc: {
    message: "Incorpora immagine"
  },
  enter_search_terms_e397b1f0: {
    message: "inserisci i termini di ricerca"
  },
  enter_the_alternative_text_for_this_image_88047c47: {
    message: "Inserisci testo alternativo per questa immagine"
  },
  file_upload_form_4aaad554: {
    message: "Modulo caricamento file"
  },
  files_c300e900: {
    message: "File"
  },
  files_index_af7c662b: {
    message: "Indice file"
  },
  folder_705fd2d7: {
    message: "Cartella"
  },
  font_size_press_down_to_select_6c25dc2d: {
    message: "Dimensioni carattere, premi per selezionare"
  },
  formatting_press_down_to_select_df728c30: {
    message: "Formattazione, premi per selezionare"
  },
  grades_a61eba0a: {
    message: "Voti"
  },
  group_navigation_99f191a: {
    message: "Esplorazione gruppo"
  },
  i_have_obtained_permission_to_use_this_file_6386f087: {
    message: "Ho ottenuto l''autorizzazione a utilizzare questo file."
  },
  i_hold_the_copyright_71ee91b1: {
    message: "Sono il proprietario del copyright"
  },
  if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5: {
    message: "Se non selezioni i diritti di utilizzo ora, questo file sar\xE0 in stato \"non pubblicato\" dopo il caricamento."
  },
  image_upload_form_7b74079a: {
    message: "Modulo caricamento immagine"
  },
  images_7ce26570: {
    message: "Immagini"
  },
  insert_equella_links_49a8dacd: {
    message: "Inserisci link Equella"
  },
  insert_link_6dc23cae: {
    message: "Inserisci link"
  },
  insert_math_equation_57c6e767: {
    message: "Inserisci equazione matematica"
  },
  link_7262adec: {
    message: "Link"
  },
  link_to_a_new_page_6c4ad034: {
    message: "Collega a una nuova pagina"
  },
  link_to_other_content_in_the_course_879163b5: {
    message: "Collega ad altro contenuto del corso."
  },
  link_to_other_content_in_the_group_3fe25379: {
    message: "Collega ad altro contenuto del gruppo."
  },
  link_to_url_52dd935c: {
    message: "Collega a URL"
  },
  links_14b70841: {
    message: "Link"
  },
  load_more_results_460f49a9: {
    message: "Carica altri risultati"
  },
  loading_25990131: {
    message: "Caricamento in corso..."
  },
  loading_failed_b3524381: {
    message: "Caricamento non riuscito..."
  },
  loading_folders_8d4d5d5a: {
    message: "Caricamento cartelle in corso..."
  },
  modules_c4325335: {
    message: "Moduli"
  },
  no_results_940393cf: {
    message: "Nessun risultato."
  },
  pages_e5414c2c: {
    message: "Pagine"
  },
  people_b4ebb13c: {
    message: "Persone"
  },
  quizzes_7e598f57: {
    message: "Quiz"
  },
  record_upload_media_5fdce166: {
    message: "Registra/Carica file multimediali"
  },
  rich_text_area_press_alt_f8_for_help_58f0f2c3: {
    message: "Area di testo RTF. Premi ALT+F8 per la guida"
  },
  search_280d00bd: {
    message: "Cerca"
  },
  search_flickr_6884b518: {
    message: "Cerca in Flickr"
  },
  select_a_file_53ba40ac: {
    message: "Seleziona un file"
  },
  select_a_folder_to_upload_your_file_into_b82d12b: {
    message: "Seleziona una cartella in cui caricare il file"
  },
  syllabus_f191f65b: {
    message: "Piano di studio"
  },
  text_color_press_down_to_select_8f5ad9b5: {
    message: "Colore testo, premi per selezionare"
  },
  the_material_is_in_the_public_domain_279c39a3: {
    message: "Il materiale \xE8 nel dominio pubblico"
  },
  the_material_is_licensed_under_creative_commons_3242cb5e: {
    message: "Il materiale \xE8 concesso in licenza da Creative Commons"
  },
  the_material_is_subject_to_fair_use_exception_41bc6a4b: {
    message: "Il materiale \xE8 soggetto all''eccezione del fair use"
  },
  this_upload_exceeds_the_file_storage_quota_please__c3a1b641: {
    message: "Questo caricamento supera il limite massimo di archiviazione file. Consultare l\u2019amministratore di sistema."
  },
  upload_8b403d05: {
    message: "Carica"
  },
  upload_a_new_file_96e6d4ff: {
    message: "Carica un nuovo file"
  },
  upload_a_new_image_890df275: {
    message: "Carica una nuova immagine"
  },
  usage_right_ff96f3e2: {
    message: "Diritto di utilizzo:"
  },
  what_would_you_like_to_call_the_new_page_d7e4488a: {
    message: "Come desideri chiamare la nuova pagina?"
  },
  wiki_home_9cd54d0: {
    message: "Home page wiki"
  }
};

_formatMessage.default.addLocale({
  it: locale
});